import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaRegCalendarAlt, FaRegClock } from "react-icons/fa";

function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = date.getUTCDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  const month = date.toLocaleDateString("en-GB", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();
  return `${day}${suffix} ${month}, ${year}`;
}

function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

export default function BlogCard({ blog }) {
  const link = `/blogs/${blog.slug}`;
  const date = blog.published_at ? formatDate(blog.published_at) : "";
  const readTime = blog.estimated_reading_time
    ? `${blog.estimated_reading_time} min read`
    : "";
  const excerpt = blog.description
    ? stripHtml(blog.description).slice(0, 130) + "..."
    : "";

  const handleCardClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <article className="blog-card-item">
      {blog.featured_image_url && (
        <Link
          to={link}
          onClick={handleCardClick}
          className="blog-card-img-link"
          tabIndex={-1}
          aria-hidden="true"
        >
          <div className="blog-card-img-wrapper">
            <img
              src={blog.featured_image_thumbnail_url}
              alt={blog.featured_image_alt || blog.title}
              width={400}
              height={240}
              loading="lazy"
              className="blog-card-img"
            />
          </div>
        </Link>
      )}

      <div className="blog-card-body">
        {/* {(date || readTime) && (
          <div className="blog-card-meta">
            {date && (
              <span className="blog-card-meta-item">
                <FaRegCalendarAlt className="blog-card-meta-icon" />
                {date}
              </span>
            )}
            {readTime && (
              <span className="blog-card-meta-item">
                <FaRegClock className="blog-card-meta-icon" />
                {readTime}
              </span>
            )}
          </div>
        )} */}

        <h3 className="blog-card-title">
          <Link to={link} onClick={handleCardClick}>
            {blog.title}
          </Link>
        </h3>

        {excerpt && <p className="blog-card-excerpt">{excerpt}</p>}

        <div className="blog-card-footer">
          <Link
            to={link}
            onClick={handleCardClick}
            className="blog-card-read-link"
          >
            <span>Read Article</span>
            <FaArrowRight className="blog-card-arrow-icon" />
          </Link>
        </div>
      </div>
    </article>
  );
}